module.exports = __webpack_public_path__ + "static/media/uib2.2f92b006.png";